<form [formGroup]="jsonFormGroup" class="py-1">
  @if (currentDisplayType === displayType.Accordion) {
    <mat-accordion>
      @for (section of sectionsOrder; track section) {
        @if (
          configSections?.[section] &&
          !!!uiConfig?.sectionsInfo?.[section]?.hideSection
        ) {
          <mat-expansion-panel
            [attr.data-cy]="configSections[section][0].data_cy || ''"
            class="accordion-title"
            [ngClass]="{ 'section-error': isHavingError(section) }"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h6
                  class="mt-3 section-title d-flex gap-1"
                  [attr.section]="section"
                  [ngClass]="section + '_tile'"
                >
                  <ng-container
                    *ngTemplateOutlet="
                      displayLabelTemplate;
                      context: { section: section }
                    "
                  ></ng-container>
                </h6>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <div
                class="section-div d-flex flex-wrap justify-content-start mt-1"
                [ngClass]="uiConfig?.sectionsInfo?.[section]?.class || 'mb-3'"
              >
                <ng-container
                  *ngTemplateOutlet="
                    configTemplate;
                    context: {
                      config: configSections[section],
                      form: jsonFormGroup,
                    }
                  "
                >
                </ng-container>
              </div>
            </ng-template>
          </mat-expansion-panel>
        }
      }
    </mat-accordion>
  }
  @if (currentDisplayType === displayType.Tab) {
    <mat-tab-group
      (selectedIndexChange)="onTabSelectionChanged()"
      (selectedTabChange)="onTabSelectionChanged()"
    >
      @for (section of sectionsOrder; track section) {
        @if (section !== "undefined" && configMainSections?.[section]) {
          <mat-tab>
            <ng-template mat-tab-label>
              <div
                class="tab-title"
                [ngClass]="{ 'section-error': isHavingError(section) }"
              >
                <ng-container
                  *ngTemplateOutlet="
                    displayLabelTemplate;
                    context: { section: section }
                  "
                ></ng-container>
              </div>
            </ng-template>
            <div class="sectionContainer">
              @for (subSec of subSections[section]; track subSec) {
                @if (!!!uiConfig?.sectionsInfo?.[subSec]?.hideSection) {
                  <ng-container
                    *ngTemplateOutlet="
                      subSectionDisplay;
                      context: { subSection: subSec }
                    "
                  ></ng-container>
                  <div
                    class="section-div d-flex flex-wrap justify-content-start mt-1"
                    [ngClass]="
                      uiConfig?.sectionsInfo?.[section]?.class || 'mb-3'
                    "
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        configTemplate;
                        context: {
                          config: configSections[subSec],
                          form: jsonFormGroup,
                        }
                      "
                    >
                    </ng-container>
                    @if (subSectionTemplates?.[subSec]) {
                      <ng-container
                        *ngTemplateOutlet="subSectionTemplates[subSec]"
                      ></ng-container>
                    }
                  </div>
                }
              }
            </div>
          </mat-tab>
        }
      }
    </mat-tab-group>
  }
  @if (currentDisplayType === displayType.None || !currentDisplayType) {
    @for (section of sectionsOrder; track section) {
      @if (
        configSections?.[section] &&
        !!!uiConfig?.sectionsInfo?.[section]?.hideSection
      ) {
        <div class="plain-title">
          @if (section !== "undefined") {
            <div
              class="plain-section-title"
              [attr.section]="section"
              [ngClass]="section + '_tile'"
            >
              <ng-container
                *ngTemplateOutlet="
                  displayLabelTemplate;
                  context: { section: section }
                "
              ></ng-container>
            </div>
          }
          <div
            class="pt-2 section-div d-flex flex-wrap justify-content-start mt-1 fs-small"
            [ngClass]="uiConfig?.sectionsInfo?.[section]?.class || 'mb-3'"
          >
            <ng-container
              *ngTemplateOutlet="
                configTemplate;
                context: {
                  config: configSections[section],
                  form: jsonFormGroup,
                }
              "
            >
            </ng-container>
          </div>
        </div>
      }
    }
  }
</form>

<ng-template #configTemplate let-configuaration="config" let-form="form">
  @for (currentConfig of configuaration; track $index) {
    <ng-container [formGroup]="form">
      @if (
        !currentConfig.isDependentControl || isConditionSatisfied(currentConfig)
      ) {
        @if (currentConfig.children?.length) {
          <ng-container
            *ngTemplateOutlet="
              configTemplate;
              context: {
                config: currentConfig.children,
                form: currentConfig.control,
              }
            "
          ></ng-container>
          @if (form?.get(currentConfig.property)?.errors) {
            <mat-error class="custom-mat-error mt-1">
              {{
                currentConfig?.parentErrorMessages?.[
                  keys(form?.get(currentConfig.property)?.errors)?.[0]
                ] || "Please review the field"
              }}
            </mat-error>
          }
        } @else {
          @if (!!!currentConfig.hide) {
            @switch (currentConfig.uiControlType) {
              @case (UIControlType.Text) {
                <ra-input-control
                  [readOnly]="readOnly"
                  [ngClass]="currentConfig?.class || ''"
                  [currentConfig]="currentConfig"
                  [parentFormGroup]="form"
                  [form]="jsonFormGroup"
                  (valueChanged)="onValueChanged()"
                >
                </ra-input-control>
              }
              @case (UIControlType.Number) {
                <ra-input-control
                  [readOnly]="readOnly"
                  [ngClass]="currentConfig?.class || ''"
                  [currentConfig]="currentConfig"
                  [parentFormGroup]="form"
                  [form]="jsonFormGroup"
                  (valueChanged)="onValueChanged()"
                >
                </ra-input-control>
              }
              @case (UIControlType.Date) {
                <ra-input-control
                  [readOnly]="readOnly"
                  [ngClass]="currentConfig?.class || ''"
                  [currentConfig]="currentConfig"
                  [parentFormGroup]="form"
                  [form]="jsonFormGroup"
                  (valueChanged)="onValueChanged()"
                >
                </ra-input-control>
              }
              @case (UIControlType.TextArea) {
                <ra-input-control
                  [readOnly]="readOnly"
                  [ngClass]="currentConfig?.class || ''"
                  [currentConfig]="currentConfig"
                  [parentFormGroup]="form"
                  [form]="jsonFormGroup"
                  (valueChanged)="onValueChanged()"
                >
                </ra-input-control>
              }
              @case (UIControlType.Dropdown) {
                <ra-dropdown-control
                  [readOnly]="readOnly"
                  [ngClass]="currentConfig?.class || ''"
                  [form]="jsonFormGroup"
                  [parentFormGroup]="form"
                  [currentConfig]="currentConfig"
                  (valueChanged)="onValueChanged()"
                >
                </ra-dropdown-control>
              }
              @case (UIControlType.Checkbox) {
                <ra-checkbox-control
                  [readOnly]="readOnly"
                  [ngClass]="currentConfig?.class || ''"
                  [parentFormGroup]="form"
                  [form]="jsonFormGroup"
                  [currentConfig]="currentConfig"
                  (valueChanged)="onValueChanged()"
                >
                </ra-checkbox-control>
              }
              @case (UIControlType.DynamicList) {
                <ra-dynamic-list
                  [readOnly]="readOnly"
                  [ngClass]="currentConfig?.class || ''"
                  [parentFormGroup]="form"
                  [form]="jsonFormGroup"
                  [currentConfig]="currentConfig"
                  (valueChanged)="onValueChanged()"
                >
                </ra-dynamic-list>
              }
              @case (UIControlType.DynamicDict) {
                <ra-dynamic-dict
                  [readOnly]="readOnly"
                  [ngClass]="currentConfig?.class || ''"
                  [parentFormGroup]="form"
                  [form]="jsonFormGroup"
                  [currentConfig]="currentConfig"
                  (valueChanged)="onValueChanged()"
                >
                </ra-dynamic-dict>
              }
              @case (UIControlType.BooleanDropdown) {
                <ra-boolean-dropdown-control
                  [readOnly]="readOnly"
                  [ngClass]="currentConfig?.class || ''"
                  [parentFormGroup]="form"
                  [form]="jsonFormGroup"
                  [currentConfig]="currentConfig"
                  (valueChanged)="onValueChanged()"
                >
                </ra-boolean-dropdown-control>
              }
              @case (UIControlType.CSV) {
                <ra-csv
                  [readOnly]="readOnly"
                  [ngClass]="currentConfig?.class || ''"
                  class="w-100"
                  [parentConfig]="jsonFormGroup"
                  [config]="currentConfig"
                  [fileSelectObj]="
                    currentConfig?.property === fileSelectObject?.fileName
                      ? ((fileSelect$ | async) ?? null)
                      : null
                  "
                >
                </ra-csv>
              }
              @case (UIControlType.External) {
                <ng-content
                  [select]="'[external=' + currentConfig.externalSelector + ']'"
                ></ng-content>
              }
              @case (UIControlType.Label) {
                <div
                  [ngClass]="currentConfig?.class"
                  [innerHTML]="currentConfig.htmlOrText | safeHtml"
                ></div>
              }
              @case (UIControlType.DragDrop) {
                <ra-dynamic-list-drag-drop
                  [readOnly]="readOnly"
                  [ngClass]="currentConfig?.class || ''"
                  [parentFormGroup]="form"
                  [form]="jsonFormGroup"
                  [currentConfig]="currentConfig"
                >
                </ra-dynamic-list-drag-drop>
              }
              @case (UIControlType.Radio) {
                <ra-radio-control
                  [readOnly]="readOnly"
                  [ngClass]="currentConfig?.class || ''"
                  [parentFormGroup]="form"
                  [form]="jsonFormGroup"
                  [currentConfig]="currentConfig"
                  (valueChanged)="onValueChanged()"
                >
                </ra-radio-control>
              }
              @case (UIControlType.Chips) {
                <ra-chip-control
                  [readOnly]="readOnly"
                  [ngClass]="currentConfig?.class || ''"
                  [parentFormGroup]="form"
                  [form]="jsonFormGroup"
                  [currentConfig]="currentConfig"
                  (valueChanged)="onValueChanged()"
                >
                </ra-chip-control>
              }
              @case (UIControlType.CSVUtils) {
                <ra-csv-utils
                  [readOnly]="readOnly"
                  [currentConfig]="currentConfig"
                  (fileSelect)="handleFileSelectEvent($event)"
                  [parentFormGroup]="form"
                  [parentConfig]="jsonFormGroup"
                ></ra-csv-utils>
              }
            }
          }
          @if (currentConfig?.nextLine) {
            <div class="w-100"></div>
          }
        }
      }
    </ng-container>
  }
</ng-template>
<ng-template #matErrorTemplate let-error="error">
  <mat-error>{{ error || "Enter valid value" }}</mat-error>
</ng-template>
<ng-template #displayLabelTemplate let-section="section">
  <span class="d-flex gap-1">
    {{ uiConfig?.sectionsInfo?.[section]?.displayLabel || section || "" }}
    <ra-tooltip
      [tooltipConfig]="uiConfig?.sectionsInfo?.[section]?.tooltipConfig"
    ></ra-tooltip>
  </span>
</ng-template>
<ng-template #subSectionDisplay let-subSection="subSection">
  <div
    class="d-flex gap-1 subSectionName"
    [ngClass]="{
      'error-text': configSections[subSection]?.isHavingError || false,
    }"
  >
    {{ uiConfig?.sectionsInfo?.[subSection]?.displayLabel || subSection || "" }}
    <ra-tooltip
      [tooltipConfig]="uiConfig?.sectionsInfo?.[subSection]?.tooltipConfig"
    ></ra-tooltip>
  </div>
</ng-template>
